import { useRouter } from 'next/router';
import { Card, CardBody, Col, Row } from 'react-bootstrap';
import { t } from 'react-switch-lang';
import Decimal from 'decimal.js';
import { useEffect } from 'react';
import { DISPATCHERS, usePaymentProcessContext } from '../../../context/PaymentProcessContext';
import SectionTitle from '../../SectionTitle';
import { ExternalLink } from '../../Links';
import { events, logAmpEvent } from '../../../utils/Amplitude';
import styles from '../../../styles/PaymentOption.module.scss';
import PaymentOptionCard from '../PaymentOptionCard';
import Button from '../../Button';
import { formatAsTestId } from '../../../utils/Helpers';

export default function PaymentOption() {
  const {
    dispatchPaymentProcess,
    paymentProcess: {
      partner,
      accountDetails,
    },
  } = usePaymentProcessContext();
  const paymentOptions = partner?.PaymentOptions;
  const paymentAmount = accountDetails?.PaymentAmount;
  const router = useRouter();

  /**
   * @param {import('../../../context/PaymentProcessContext').PaymentOption} paymentOption
   * @param {number} totalFee
   */
  const handlePOSelection = (paymentOption, totalFee) => {
    const totalAmount = new Decimal(paymentAmount).add(new Decimal(totalFee)).toNumber();
    const paymentOptionData = {
      ...paymentOption,
      totalFee,
      totalAmount,
    };
    dispatchPaymentProcess(DISPATCHERS.SELECT_PAYMENT_OPTION(paymentOptionData));
    router.push(`${window.location.pathname}#review`, undefined, { shallow: true });
  };

  useEffect(() => {
    logAmpEvent(events.USER_VIEWED_PAYMENT_OPTIONS_PAGE);
  }, []);

  return (
    <>
      <Card>
        <CardBody>
          <Row>
            <Col md={12} className="d-flex flex-column justify-content-md-center">
              <SectionTitle
                title={t('PaymentOption_Page_Title')}
              >
                <ExternalLink
                  text={t('PaymentOption_Page_SubtitleLink')}
                  href={t('Link_PaySimply_Help_WhyChargeFees')}
                  aria-label={t('PaymentOption_Page_HelpCentre_Fees_LinkDescription')}
                  ampEvent={events.USER_CLICKED_PAYSIMPLY_FEES_HELPCENTRE_LINK}
                  className={styles.helpCentreLink}
                  testId={formatAsTestId('paysimply fees helpcentre', 'external link')}
                />
              </SectionTitle>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={12} role="tablist">
              {paymentOptions?.map((option) => (
                <PaymentOptionCard
                  key={option.Name}
                  paymentOptionInfo={option}
                  paymentAmount={paymentAmount}
                  onSelect={handlePOSelection}
                />
              ))}
            </Col>
          </Row>
        </CardBody>
      </Card>
      <div className={styles.buttonContainer}>
        <Button
          text={t('PaymentProcess_ButtonBack')}
          ampEvent={events.USER_CLICKED_BACK_BUTTON}
          ampEventProps={{ Step: 'Payment Option' }}
          onClick={() => router.push(window.location.pathname, undefined, { shallow: true })}
          testId={formatAsTestId('payment process back', 'button')}
        />
      </div>
    </>
  );
}
